import DigestAlerts from './DigestAlerts';

export default DigestAlerts;
